import { CRUDMutations } from '@/utils/store-utilities'

const defaultItem = (item) => ({
  ...item,
})

export const state = () => ({
  items: [],
})

export const mutations = {
  ...CRUDMutations(defaultItem),
}

export const getters = {}

export const actions = {
  addPackage({ commit }, item) {
    return this.$axios.$post('admin/packages/create', { ...item }).then((response) => {
      commit('add', { ...response.data })
    })
  },
  removePackage({ commit }, item) {
    return this.$axios.$delete(`admin/packages/${item.id}`).then((response) => {
      if (response.data) {
        commit('remove', item)
      }
    })
  },
  updatePackage({ commit }, item) {
    return this.$axios.$put(`admin/packages/${item.id}`, { ...item }).then((response) => {
      commit('update', { ...response.data })
    })
  },
  fetchPackages({ commit }) {
    return this.$axios.$get('admin/packages').then((response) => {
      commit('load', response.data)
    })
  },
}
